/* Ad landing pinning. Plain collection links keep Shopify's normal order. */
(async () => {
  const config = document.getElementById('ClubCuratedConfig');
  const grid = document.querySelector('[data-curated-grid]');
  if (!config || !grid) return;
  const { parameter, root } = JSON.parse(config.textContent);
  const params = new URLSearchParams(location.search);
  const raw = params.get(parameter);
  if (!raw || Number(params.get('page') || 1) > 1) return;
  let handle = raw, variant = params.get('variant');
  if (raw.includes('/products/')) {
    try {
      const linked = new URL(raw, location.origin);
      handle = linked.pathname.split('/products/')[1]?.split('/')[0];
      variant = linked.searchParams.get('variant') || variant;
    } catch { return; }
  }
  if (!handle || !/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return;
  if (variant && !/^\d+$/.test(variant)) variant = null;
  // Filtering and sorting submit a fresh query; pagination also leaves the pin behind.
  document.querySelectorAll('.pagination a').forEach(link => {
    const url = new URL(link.href);
    url.searchParams.delete(parameter);
    url.searchParams.delete('variant');
    link.href = url.pathname + url.search;
  });
  let card = [...grid.querySelectorAll(':scope > [data-product-handle]')].find(el => el.dataset.productHandle === handle);
  if (!card || variant) {
    const url = new URL(`${root}products/${encodeURIComponent(handle)}`, location.origin);
    url.searchParams.set('section_id', 'club-curated-card');
    if (variant) url.searchParams.set('variant', variant);
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fetched = doc.querySelector('[data-product-handle]');
      if (!fetched || fetched.dataset.productHandle !== handle) return;
      if (card) card.replaceWith(fetched);
      card = fetched;
    } catch { return; } finally { clearTimeout(timeout); }
  }
  const first = grid.querySelector(':scope > [data-product-handle]');
  if (card.parentElement !== grid) {
    grid.querySelector('.empty-state')?.remove();
    grid.prepend(card);
  } else if (first && card !== first) {
    // Swap positions without changing the intervening product order.
    const marker = document.createComment('curated swap');
    card.before(marker);
    first.replaceWith(card);
    marker.replaceWith(first);
  }
  card.dataset.curatedFirst = 'true';
})();
